<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-form
          :model="formData"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名" prop="name"
                          :rules="[
      { required: true, message: '请输入姓名', trigger: 'blur'},
    ]"
            >
              <el-input
                  type="text"
                  placeholder="请输入姓名"
                  v-model="formData.name"

              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证件号" prop="num"
                          :rules="[
                              { required: true, message: '请输入证件号', trigger: 'blur'},
                          ]"
            >
              <el-input
                  type="text"
                  placeholder="请输入证件号"
                  v-model="formData.num"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">提交认证
            </el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
          </el-col>
        </el-row>

      </el-form>

    </div>
  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import namekey from "../../../utils/namekey";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'CertPersonApplyOther',
  components: {
    PicUploader,
  },
  data: function () {
    return {
      validator,
      saveLoading: false,
      showArea: false,
      showNamekey: false,
      areaList: {},
      namekeyList: {},
      areaValue: '',
      submitType: '',
      formData: {
        id: 0,
        type: 1,
        areas: '',
        nprovince: '',
        registstatus: '',
        ncity: '',
        ncounty: '',
        province: '',
        city: '',
        county: '',
        certificatepic: [] // [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"},{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
      },
    }
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "其他类型认证"
    // console.log(area)
    that.areaList = area;
    that.namekeyList = namekey;
    that.formData.id = this.$route.query.id || 0;
    that.fetch();
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    onNamekeyConfirm(values) {
      console.log(values);
      this.formData.namekey = values[2].code;
      this.formData.nprovince = values[0].name;
      this.formData.ncity = values[1].name;
      this.formData.ncounty = values[2].name;
      this.showNamekey = false;
    },
    onAreaConfirm(values) {
      console.log(values);
      this.formData.area = values[2].code;
      this.formData.province = values[0].name;
      this.formData.city = values[1].name;
      this.formData.county = values[2].name;
      this.showArea = false;
    },

    submitForm(formName) {

      let that = this;
      that.formValidate = true;

      that.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          console.log(that.formData)
          that.formValidate = true;
          let valiOk = true;

          for (let field in that.formData) {

            if (!this.formData.name) {
              that.$message.warning('请选择姓名');
              return
            }
            if (!this.formData.num) {
              that.$message.warning('请选择证件号');
              return
            }
          }
          that.saveLoading = true;

          that.$api.post('/api/user/perCertSubmitSimple', that.formData, (res) => {
            that.saveLoading = false;
            that.$message.success('认证成功')
            setTimeout(function () {
              rbLink({
                name: 'MyExperience',
                query: {}
              });
            }, 200);
          }, (res) => {
            that.$message.warning(res.msg);
            that.saveLoading = false;
          })

        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

        if (!this.formData.name) {
          Toast('请选择姓名');
          return
        }
        if (!this.formData.num) {
          Toast('请选择证件号');
          return
        }
      }
      that.saveLoading = true;

      that.$api.post('/api/user/perCertSubmitSimple', that.formData, (res) => {
        that.saveLoading = false;
        Toast.success('认证成功')
        setTimeout(function () {
          rbLink({
            name: 'MyExperience',
            query: {}
          });
        }, 200);
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },
    fetch() {
      let that = this;
      that.$api.post('/api/user/certData', {}, (res) => {
        that.user = res.data;
      }, (res) => {

//                    Toast.fail(res.msg);
      })
    }

  }
}
</script>



// WEBPACK FOOTER //
// CertPersonApplyOther.vue?cb849e14